import type {
  Dispatch,
  FormEventHandler,
  ReactNode,
  SetStateAction
} from 'react';
import { useRef } from 'react';
import { Transition } from 'react-transition-group';
import { BtnSubmit } from 'components/btn-submit';
import { BtnSecondary } from '../btn-secondary';
import { useOutsideClick } from '../../hooks/use-outside-click';
import {
  ButtonsContainer,
  ConfirmPopupStyled,
  PopupContent,
  Title
} from './style';
import { defaultStyle, duration, transitionStyles } from './transition';

interface ConfirmPopupProps {
  title: ReactNode;
  setShow: Dispatch<SetStateAction<boolean>>;
  onSubmit: () => void;
  show: boolean;
  customWidth?: string;
}

export const ConfirmPopup = ({
  title,
  setShow,
  onSubmit,
  show,
  customWidth
}: ConfirmPopupProps) => {
  const ref = useRef(null);
  useOutsideClick(ref, () => setShow(false));

  const handleSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <Transition in={show} mountOnEnter unmountOnExit timeout={duration}>
      {(state) => (
        <ConfirmPopupStyled
          style={{
            ...defaultStyle,
            ...transitionStyles[state]
          }}
        >
          <PopupContent ref={ref} customWidth={customWidth}>
            <Title>{title}</Title>
            <ButtonsContainer onSubmit={handleSubmit}>
              <BtnSecondary minWidth="130px" onClick={() => setShow(false)}>
                Hі
              </BtnSecondary>
              <BtnSubmit minWidth="130px">Так</BtnSubmit>
            </ButtonsContainer>
          </PopupContent>
        </ConfirmPopupStyled>
      )}
    </Transition>
  );
};
